import { Box, IconButton, Typography, Avatar, Menu, MenuItem, AppBar as MuiAppBar } from '@mui/material';
import { Notifications, Logout, Settings, Person, Menu as MenuIcon, Refresh } from '@mui/icons-material';
import { useState } from 'react';
import { useAuth } from '@/hooks/auth';
import { useSidebarState } from 'react-admin';

export const RostaAppBar = () => {
  const { user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [, setSidebarOpen] = useSidebarState();

  return (
    <MuiAppBar
      position="fixed"
      elevation={0}
      sx={{
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        color: 'text.primary',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', height: '64px', px: '16px', gap: '8px' }}>
        <IconButton edge="start" onClick={() => setSidebarOpen(false)} sx={{ color: 'text.secondary', mr: '4px' }}>
          <MenuIcon />
        </IconButton>

        <Box component="img" src="/logo.svg" alt="Rosta" sx={{ height: '28px', flexShrink: 0 }} />
        <Box sx={{ width: '1px', height: '20px', bgcolor: 'divider', opacity: 0.5, mx: '8px', flexShrink: 0 }} />
        <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500, whiteSpace: 'nowrap', flexShrink: 0 }}>
          Rosta HR
        </Typography>

        <Box sx={{ flex: 1, minWidth: 0 }} />

        <IconButton size="small" sx={{ color: 'text.secondary', flexShrink: 0 }}>
          <Notifications fontSize="small" />
        </IconButton>
        <IconButton size="small" onClick={(e) => setAnchorEl(e.currentTarget)} sx={{ ml: '4px', flexShrink: 0 }}>
          <Avatar sx={{ width: 32, height: 32, bgcolor: 'primary.main', fontSize: '0.875rem', fontWeight: 600 }}>
            {user?.name?.charAt(0) ?? 'U'}
          </Avatar>
        </IconButton>
        <IconButton size="small" onClick={() => window.location.reload()} sx={{ color: 'text.secondary', flexShrink: 0 }}>
          <Refresh fontSize="small" />
        </IconButton>
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        slotProps={{ paper: { sx: { bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', minWidth: 180, mt: 1 } } }}
      >
        <MenuItem sx={{ gap: 1.5, py: 1 }}><Person fontSize="small" /> Profile</MenuItem>
        <MenuItem sx={{ gap: 1.5, py: 1 }}><Settings fontSize="small" /> Settings</MenuItem>
        <MenuItem sx={{ gap: 1.5, py: 1, color: 'error.main' }} onClick={logout}><Logout fontSize="small" /> Logout</MenuItem>
      </Menu>
    </MuiAppBar>
  );
};
